
import {
  REMOVE_FOLLOWED_GROUP,
  RESET_LEADERS_PAGE,
  SET_FOLLOWED_GROUPS,
  SET_ALL_GROUPS_FOR_FOLLOWED_LEADERS,
  SET_FOLLOWED_POSTS,
  SET_FOLLOW_FILTER,
  SET_FOLLOW_LIST,
  SET_LEADERS_LIST,
  SET_LEADER_GROUPS,
  SET_LEADER_SEARCH_TERM,
  UPDATE_FOLLOW_LIST,
} from '../../constants';
import { IReduxAction } from '../../interfaces';

export interface ILeadersListConfig {
  search: string;
  filter: string;
  sort: string;
  pagination: {
    limit: number,
    lastItem: object | null,
  };
}

interface ILeadersState {
  follow: object[];
  followFilter: string;
  list: object[];
  listLoaded: Boolean;
  selected: object | null;
  listConfig: ILeadersListConfig;
}

const initState: ILeadersState = {
  follow: [],
  followFilter: 'all',
  list: [],
  listLoaded: false,
  selected: null,
  listConfig: {
    search: '',
    filter: 'all',
    sort: 'date-descend',
    pagination: {
      limit: 25,
      lastItem: null,
    },
  },
};

export function leadersReducer(state = initState, action: IReduxAction) {
  switch (action.type) {
    case UPDATE_FOLLOW_LIST:
      const otherFollowings =
        state.follow.filter((item: any) =>
          item.leader.id !== action.payload.leader.id);
      return {
        ...state,
        follow: [
          ...otherFollowings,
          action.payload,
        ],
      };

    case REMOVE_FOLLOWED_GROUP:
      const following =
        state.follow.map((item: any) => {
          if (item.leader.id === action.payload.leader.id) {
            if (action.payload.groups.length) {
              return {
                ...item,
                groups: action.payload.groups,
              };
            }
            return null;
          }

          return item;
        });
      return {
        ...state,
        follow: following.filter(Boolean),
      };

    case SET_LEADERS_LIST:
      return {
        ...state,
        list: action.payload.leaders,
        listLoaded: true,
        listConfig: {
          ...state.listConfig,
          pagination: {
            ...state.listConfig.pagination,
            lastItem: action.payload.lastItem,
          },
        },
      };

    case SET_LEADER_SEARCH_TERM:
      return {
        ...state,
        listConfig: {
          ...state.listConfig,
          search: action.payload,
        },
      };

    case SET_LEADER_GROUPS:
      const addGroups = state.list.map((item: any) => {
        if (item.id === action?.payload[0]?.ownerId) {
          return {
            ...item,
            groups: action.payload,
          };
        }

        return item;
      });

      return {
        ...state,
        list: [
          ...addGroups,
        ],
      };

    case SET_FOLLOW_LIST:
      return {
        ...state,
        follow: action.payload,
      };

    case SET_FOLLOWED_GROUPS:
      const followedGroups = state.follow
        .map((followed: any) => {
          if (followed.leader.id === action.payload.leaderId) {
            return {
              ...followed,
              groups: action.payload.groups,
              loaded: true,
            };
          }

          return followed;
        });

      return {
        ...state,
        follow: [
          ...followedGroups,
        ],
      };

    case SET_ALL_GROUPS_FOR_FOLLOWED_LEADERS:
      const followedLeaders = state.follow
          .map((followed: any) => {
            if (followed.leader.id === action.payload.leaderId) {
              return {
                ...followed,
                allGroups: action.payload.allGroups,
                loaded: true,
              };
            }
            return followed;
          });
      return {
        ...state,
        follow: [
          ...followedLeaders,
        ],
      };

    case SET_FOLLOWED_POSTS:
      const followedPosts =
        (group: any) => group.id === action.payload.groupId
          ? ({
            ...group,
            posts: action.payload.posts,
          })
          : group;

      return {
        ...state,
        follow: [
          ...state.follow
            .map((followed: any) => {
              return followed.leader.id === action.payload.leaderId ?
                {
                  ...followed,
                  groups: [
                    ...followed.groups.map(followedPosts),
                  ],
                }
                : followed;
            }),
        ],
      };

    case SET_FOLLOW_FILTER:
      return {
        ...state,
        followFilter: action.payload,
        listLoaded: false,
      };

    case RESET_LEADERS_PAGE:
      return {
        ...state,
        ...initState,
      };

    default:
      return state;
  }
}
